module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABCUlEQVQ4T42TCw3CQBBEqQKQUByAg0oAB0UBOKA4AAdIQEJxAAqoA3AA85rd5rhcP5tMttnP7OzdNZulbaPwXlha+iV/EW5xeZbovyq2EA5CY/lc/iy8hV3YExMwuRTwKUMBAzolMcHDmn1yTIISCApPxAQ0UjRkfzUhAazs3SffSZHPedQEQgKCJNvEgDEIVDEB+5cCfshWpgCSTgHScwE/xVDbQOQrMBXmqcY7qemBgEYm+/6fERaakc9htwogoJlERXCEgGHU8Sq3voIrYJVc6FPBEP6LdajAB8JKwdhBopAB1P+9g9qa/RpRcjT2k3xj38lrJEcC1kL4Ck/Bz8Ovea7Y3eraQT8KPjhxNoSmdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/bottomfix/qq.png
// module id = dpP/
// module chunks = 0